export default __webpack_public_path__ + "static/Tire-Removal-48ba5592fc20a1216bc617b39cf80cdb.jpg";